import {zDateTime} from '@brunata-angular/util';
import {z} from 'zod';

export const accountPeriodSchema = z.object({
    startDate: zDateTime,
    endDate: zDateTime,
});

export type AccountPeriod = z.infer<typeof accountPeriodSchema>;
